import { gql } from "@apollo/client";

export const GET_ALL_USUARIOS_RESPONSABLES = gql`
    query allUsuariosResponsables($idAreaReclamo: Int!) {
        allUsuariosResponsables(idAreaReclamo: $idAreaReclamo){
            idUsuario
            nombre
            apellido
        }
}`;

export const adaptUsuariosResponsablesArray = (usuarios) =>
structuredClone(usuarios?.allUsuariosResponsables)?.
map((usuario) => ({
  id: usuario?.idUsuario,
  displayName: usuario?.nombre + ' ' + usuario?.apellido
}));